import { createAction, props } from '@ngrx/store';

export const getProduct = createAction(
  '[Products] Get Product',
  props<{ productId: number }>()
);
export const getProductSuccess = createAction(
  '[Products] Get Product Success',
  props<{ product: any }>()
);
export const getProductFailure = createAction(
  '[Products] Get Product Failure',
  props<{ error: Error }>()
);
